import { configureStore } from '@reduxjs/toolkit'
import { baseApi } from 'shared/api/baseApi'
import { customApi } from 'shared/api/customApi'
import { fetchApi } from 'shared/api/fetchApi'
import { errorMiddleware } from './errorMiddleware'
import { rootReducer } from './rootReducer'

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => [
        ...getDefaultMiddleware({
            serializableCheck: false,
        }),
        baseApi.middleware,
        customApi.middleware,
        fetchApi.middleware,
        errorMiddleware,
    ],
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
